// extracted by mini-css-extract-plugin
export default {"root":"SplashScreen_root__bes3X"};